import { render } from "./KryptonPopinFooter.vue?vue&type=template&id=ffd5bc86&lang=pug"
import script from "./KryptonPopinFooter.vue?vue&type=script&lang=js"
export * from "./KryptonPopinFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__